import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { getAllProjects } from '../../../../redux/features/courseSlice';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { coursePerformanceAnalyticsHeader } from './utils/coursePerfomanceAnalyticsHeader';
import { getCoursePerfomanceAnalytics } from '../../../../redux/features/crdMigrationSlice';
import GlobalTableNoPagination from '../../../../components/CustomTableWithPagination/GlobalTableNoPagination';

export default function CoursePerfomanceAnalytics() {
  // normal variable
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  const allProjects = useSelector((state) => state.course.projects);
  const projectLoading = useSelector((state) => state.course.loading);
  const loading = useSelector((state) => state.crdMigration.coursePerfomanceAnalyticsTable.loading);
  const coursePerfomanceAnalyticsTable = useSelector((state) => state.crdMigration.coursePerfomanceAnalyticsTable.data);
  //--------------------------------------------------------------------------

  // react state
  const [project, setProject] = useState({ id: -1, name: 'All' });
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));

  const styleString = `tbody tr:first-child {
    font-weight : 700 ;
    background : #b8ae89;
    }`;

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const totalValueRow = useMemo(() => {
    if (!coursePerfomanceAnalyticsTable?.total || !Object.keys(coursePerfomanceAnalyticsTable?.total).length) return {};

    return Object.entries(coursePerfomanceAnalyticsTable?.total).reduce(
      (acc, [key, value]) => {
        acc[key.slice(6)] = value;
        return acc;
      },

      {},
    );
  }, [coursePerfomanceAnalyticsTable]);

  // EXCEPT CRO ---------------------------------------------
  useEffect(() => {
    dispatch(getAllProjects());
  }, []);
  // ---------------------------------------------------------

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      projectId: project?.id,
      fromDate,
      toDate,
    }),
    [project, fromDate, toDate],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  useEffect(() => {
    dispatch(getCoursePerfomanceAnalytics(dispatchParams));
  }, [dispatchParams, dispatch]);
  //-------------* Table Fetch *-----------------------------

  return (
    <GlobalWrapper title={'Course Performance Analytics'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <FromAndToDatePicker fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate} />
          <GlobalSelectFieldWithoutFormikNew
            label={'Project'}
            data={[{ id: -1, name: 'All' }, ...allProjects]}
            keys={{
              itemId: 'id',
              itemValue: 'name',
            }}
            selectedDetails={project}
            setChange={setProject}
            sx={{
              width: { xs: '100%', sm: 200 },
            }}
            disabled={projectLoading}
          />
        </Stack>
        <GlobalTableNoPagination
          rowUniqueId="course_id"
          headers={coursePerformanceAnalyticsHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={coursePerfomanceAnalyticsTable?.course}
          permanentFirstRow={{ ...totalValueRow, course_name: 'Total' }}
          customeStyleString={styleString}
        />
      </Stack>
    </GlobalWrapper>
  );
}
